import { FC } from "react";

const NotFound: FC = () => {
	return <main>Page not found!</main>;
};

export default NotFound;
